import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { CoreService } from "app/core/core.service";
import { Observable, forkJoin, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RequestApi } from "../api-services/request-api/request-api.models";
import {
  IWorkorderOrServiceRequestDetail,
  IWorkorderOrServiceRequestSummary,
  RequestSourceTypeEnum,
} from "../models/request";
import { UtilService, extractForemanMedias } from "./util.service";

@Injectable()
export class RequestResolverService {
  constructor(
    private router: Router,
    private requestApiService: RequestApi,
    private coreService: CoreService,
    private utilsService: UtilService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<IWorkorderOrServiceRequestDetail> {
    const id = Number.parseInt(route.params["id"]);
    const extraState = this.router.getCurrentNavigation().extras.state;
    const requestSummary: IWorkorderOrServiceRequestSummary =
      extraState.requestSummary;
    const source = requestSummary.source;
    const serviceRequestId = requestSummary.serviceRequestId;
    const formattedServiceRequestDetail$ = serviceRequestId
      ? this.requestApiService.getServiceRequestById(serviceRequestId).pipe(
          map((serviceRequest) => {
            return this.utilsService.formatRawServiceRequestToServiceRequest(
              serviceRequest,
              requestSummary,
            );
          }),
        )
      : of(null);
    if (source === RequestSourceTypeEnum.workorderRequest) {
      return forkJoin([
        this.requestApiService.getWorkorderById(id),
        this.requestApiService.getDocumentsByWorkorderId(id),
        formattedServiceRequestDetail$,
      ]).pipe(
        map(
          ([
            workorderRequestDetail,
            documents,
            serviceRequestDetail,
          ]): IWorkorderOrServiceRequestDetail => {
            const foremanMedias = extractForemanMedias(documents);
            return {
              ...workorderRequestDetail,
              source,
              foremanMedias,
              serviceRequestDetail,
              requestSummary,
            };
          },
        ),
        catchError((error) => {
          void this.router.navigate(["list"]);
          return of(null);
        }),
      );
    } else {
      return formattedServiceRequestDetail$.pipe(
        catchError((error) => {
          void this.router.navigate(["list"]);
          return of(null);
        }),
      );
    }
  }
}
